// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  hullId: __t.u64().primaryKey().name("hull_id"),
  systemId: __t.string().name("system_id"),
  denKey: __t.string().name("den_key"),
  slot: __t.u8(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  yaw: __t.f64(),
  ai: __t.string(),
  writer: __t.identity(),
  updatedAt: __t.timestamp().name("updated_at"),
});
